module.exports = __webpack_public_path__ + "static/img/system1.02241568.png";